import { Flex, FormInput } from '@sparrowengg/twigs-react';
import { WebhookStateValues } from 'features/apps/add-apps/types';
import { urlRegex } from 'features/webhook/constants';
import { UseFormRegister } from 'react-hook-form';

const TokenAuthentication = ({
  register,
  errors
}: {
  register: UseFormRegister<WebhookStateValues>;
  errors: any;
}) => {
  return (
    <Flex flexDirection="column" gap="$8" css={{ marginTop: '$3' }}>
      <AuthFields register={register} errors={errors} />
    </Flex>
  );
};

export default TokenAuthentication;

export const AuthFields = ({
  register,
  errors
}: {
  register: UseFormRegister<WebhookStateValues>;
  errors: any;
}) => {
  return (
    <>
      <FormInput
        label="Client ID"
        requiredIndicator
        {...register('properties.headers.clientId', {
          required: 'Client Id is required'
        })}
        size="lg"
        error={errors?.properties?.headers?.clientId?.message}
        errorBorder={errors?.properties?.headers?.clientId}
      />
      <FormInput
        label="Client Secret"
        requiredIndicator
        {...register('properties.headers.clientSecret', {
          required: 'Client Secret is required'
        })}
        size="lg"
        error={errors?.properties?.headers?.clientSecret?.message}
        errorBorder={errors?.properties?.headers?.clientSecret}
      />
      <FormInput
        label="Token URL"
        requiredIndicator
        size="lg"
        {...register('properties.headers.tokenURL', {
          required: 'Token URL is required',
          pattern: {
            value: urlRegex,
            message: 'Please enter a valid Token URL'
          }
        })}
        error={errors?.properties?.headers?.tokenURL?.message}
        errorBorder={errors?.properties?.headers?.tokenURL}
      />
    </>
  );
};
